"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveCardImage = exports.StyledImage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var StyledImage = (0, _styledComponents.default)('img').withConfig({
  displayName: "DomestikaLiveCardImage__StyledImage",
  componentId: "sc-8x5k8b-0"
})({
  width: '100%',
  height: '100%',
  zIndex: 0,
  float: 'left',
  marginBottom: function marginBottom(_ref) {
    var imageMarginBottom = _ref.imageMarginBottom;
    return "".concat(imageMarginBottom, "px");
  },
  objectFit: 'cover'
}, (0, _css.default)({
  borderRadius: 4
}));
exports.StyledImage = StyledImage;

var DomestikaLiveCardImage = function DomestikaLiveCardImage(_ref2) {
  var imageUrl = _ref2.imageUrl,
      lazyLoading = _ref2.lazyLoading,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["imageUrl", "lazyLoading"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      imageMarginBottom = _useState2[0],
      setImageMarginBottom = _useState2[1];

  return _react.default.createElement(StyledImage, (0, _extends2.default)({
    ref: function ref(node) {
      if (node !== null) {
        setImageMarginBottom(node.parentNode.getBoundingClientRect().height * -1);
      }
    },
    imageMarginBottom: imageMarginBottom,
    src: imageUrl,
    loading: lazyLoading ? 'lazy' : 'eager'
  }, props));
};

exports.DomestikaLiveCardImage = DomestikaLiveCardImage;
DomestikaLiveCardImage.defaultProps = {
  imageUrl: null,
  lazyLoading: false
};